export type PiAsset = {
    Name: string;
    Children: PiAsset[];
    Capabilities: Capability[];
    Guid: string;
    WorkCenter: string;
    Description: string;
    Alias: string;
}


export function findAssetByCapabillityGuid(asset: PiAsset, guid: string): PiAsset | undefined {
    if (Array.isArray(asset.Capabilities) && asset.Capabilities.some(capability => capability.Guid === guid)) {
        return asset;
    }

    for (const child of Array.isArray(asset.Children) ? asset.Children : []) {
        if (!child) {
            continue;
        }
        const found = findAssetByCapabillityGuid(child, guid);
        if (found) {
            return found;
        }
    }
    return undefined;
}

interface Capability {
    Name: string;
    Guid: string;
}
